import {
	getService as getServiceGetter,
	getServiceBySlug as getServiceBySlugGetter,
	getAllServices as getAllServicesGetter,
	getAllServicesList as getAllServicesListGetter,
} from '@/store/modules/apps/getters';
import { useStore } from '@/utils/store';
import { Service, ServiceId } from '@ply-io/ply-front-shared-utilities';

export const useAppsGetters = () => {
	const { getter } = useStore();
	return {
		getAllServices: getter<Record<ServiceId, Service>>(getAllServicesGetter),
		getAllServicesList: getter<Service[]>(getAllServicesListGetter),
		getService: getter<(id: ServiceId) => Service | undefined>(getServiceGetter),
		getServiceBySlug: getter<(slug: string) => Service | undefined>(getServiceBySlugGetter),
	};
};
